export default {
  /**邀请回饋首页 start */
  inviToReback: "邀請回饋",
  accumuRewrds: "我已獲得累計獎勵",
  completedTranscation: "好友完成1手以上永續合約交易，即可獲得10USDT額外獎勵",
  inviteQuick: "虛位以待，快點行動起來吧～",
  currWeekRank: "本週排行",
  weekRank: "榜單排名",
  inviteNum: "邀請人數",
  rebackAmount: "回饋金額",
  checkAllRanks: "查看完整榜單",
  rebackRegu: "獎勵規則",
  rebaRegu1:
    "交易回饋活動期間內，被推薦人完成開戶並交易任意產品，推薦人即可獲得25%的佣金（開倉手續費+平倉手續費）回饋。注：單個客戶回饋上限500USDT，多推多拿，無上限",
  rebaRegu2:
    "二重獎勵：推薦開戶活動期間內，被推薦人完成1手以上永續合約交易，推薦人即可獲得10USDT額外獎勵。",
  shareOnce: "一鍵分享",
  myBill: "我的海報",
  shareToFace: "面對面邀請",
  sharOnceTitle: "好友{phone}發來邀請",
  sharOnceText: "邀請您注册BTCC可獲得5USDT贈金活動",
  myShareQrCode: "我的邀請QR Code",
  shareActiveRegu: "活動規則",
  shareActiveTime: "活動時間：長期有效 活動對象：真實用戶；",
  shareActiveSpire: "獎勵計算有效期：被邀請人激活60天內；",
  shareActiveReward:
    "交易回饋：獎勵計算有效期內，被邀請人完成開戶並激活交易，推薦人即可獲得對應的交易回饋USDT；",
  shareActiveTip: "注：邀請1個好友交易回饋上限500USDT，多推多拿，無上限。",
  shareActiveAtten: "注意事項：",
  shareAtiveRegu1:
    "被推薦人必須通過推薦人的個人推薦連結（或QR Code）完成開戶，否則將不視為有效推薦，即無法享受客戶交易贈金，真實用戶才能生成個人推薦連結（或QR Code）；",
  shareAtiveRegu2: "交易手數計算：被推薦人激活後60天內的所有平倉手數；",
  shareAtiveRegu3:
    "回饋以自然日計算，將在每個工作日(週一至週五)進行發放，如遇假期將順延；",
  shareAtiveRegu4: "當平台活動與邀請回饋產生沖突時，請視平台其他活動規則優先；",
  shareAtiveRegu5:
    "BTCC保留本條款的最終解釋權，及隨時修改或終止本優惠的權利，而無須事先作出通知。",
  /**邀请回饋首页 end */

  /**邀请记录，回饋记录 start */
  inviteReocrd: "邀請記錄",
  rebackRecord: "回饋記錄",
  invitedAccount: "邀請人賬號",
  inviteTime: "邀請時間",
  status: "狀態",
  checkMore: "查看更多",
  noRecord: "查無記錄！",
  type: "類型",
  rebaNum: "回饋數",
  activited: "已激活",
  notActive: "未激活",
  /**邀请记录，回饋记录 end */
  /**排行榜 start */
  rankList: "排行榜",
  yourCurrWeekData: "，您本週數據",
  billboard: "排名榜",
  phone: "手機號",
  cumulateReback: "累計回饋",
  noData: "暫無數據",
  /**排行榜 end */
  /**账户等级 start */
  account: "賬戶，",
  accountLevel: "賬戶等級",
  miniAccount: "迷你賬戶",
  stdAccount: "標準賬戶",
  vipAccount: "VIP賬戶",
  stdFeeCut: "手續費降6.66%",
  vipFeeCut: "手續費狂降20%",
  currYouAre: "您當前是",
  min: "迷你賬戶",
  std: "標準賬戶",
  dia: "VIP賬戶",
  superValueReco: "超值推薦",
  invest: "充值（{unit}）",
  upgradeQuick: "立即升級",
  moreGradeProfit: "後期將陸續開放更多賬戶等級權益，敬請期待",
  konwAccountLevel: "了解賬戶等級",
  whatsAccountLevel: "什麼是賬戶等級",
  thisIsAccountLevel:
    "請根據您累計充值的USDT，主動聯繫客服進行賬戶升級；充值越多，賬戶等級越高，可享受的手續費越低，交易成本越低，更多權益正快馬加鞭趕來。",
  whichAccountLevel: "有哪些賬戶等級",
  accountLevelTypes: "BTCC賬戶等級分為迷你、標準、VIP三種",
  accountLevCondiAndProfit: "賬戶等級條件與權益",
  feeRate: "費率",
  level: "等級",
  deposit: "存款",
  profit: "權益",
  mini: "迷你",
  noRights: "無特權",
  standard: "標準",
  stdFeeCuts: "費率直降6.66%",
  vipFeeCuts: "費率狂降20%",
  moreCutToFees: "具體費率減免見資金費率",
  example: "舉例",
  exampleDetail:
    "“以現價BTC/USDT8000USDT 計算手續費，用戶累計交易50手BTC/USDT永續合約為例”",
  noRecharge: "(無優惠)",
  cut40: "(直降40USDT)",
  cut120: "(狂降120USDT)",
  minGradeAtten: "立即升級可享受更多權益！",
  stdGradeAtten: "繼續升級可享受更多權益！",
  diaGradeAtten: "立即交易享受更多優惠吧！",
  /**账户等级 end */

  /**账户升级start */
  appliUpgrade: "申請升級",
  accountNumber: "賬戶號碼",
  upgradeTo: "升級成為",
  submit: "提交",
  upgradeNeedKnow: "賬戶升級須知：",
  upgradeNeedKnow1: "1.升級前請確保您所選擇需要升級的賬戶裡沒有持倉與掛單；",
  upgradeNeedKnow2: "2.客服會於您申請後的下一個工作日中午前審批處理；",
  upgradeNeedKnow3: "3.審批後，您只需重新登錄即可享受更佳的投資體驗。",
  accountUpgrade: "賬戶升級",
  applyPno: "申請提交成功！ （申請編號：{pno}）",
  applyNumber: "閣下的BTCC賬戶號碼：",
  applyFrom: "申請從",
  applyTo: "賬戶升級為",
  applyResTime: "客服會於您申請後的下一個工作日中午前審批處理",
  /**账户升级end */

  accountNoDot: "賬戶",
  bonus: "贈金",
  cashBack: "回饋",

  // 邀请回饋
  inviteHasInvitedUser: "已邀請用戶",
  inviteCumulativeBack: "累計回饋(USDT)",
  inviteFriend: "邀請好友",
  inviteFriendDesc:
    "與我一起加入BTCC並每日幸運抽贈金！ BTCC福利中心有高達1BTC獎勵等你拿。填寫我的推薦碼來註冊吧！",
  inviteMyInviteLink: "我的邀請連結：",
  inviteShareLink: "分享連結",
  inviteCode: "邀請碼：",
  inviteCopy: "複製",
  inviteNow: "立即邀請",
  inviteToUser: "邀請用戶",
  inviteMyReward: "我的回饋",
  inviteUser: "用戶",
  inviteRegisterTime: "註冊時間",
  inviteNoInvitePerson: "暫無被邀請的人,",
  inviteStartInvite: "開始邀請",
  inviteReward: "回饋（USDT）",
  inviteQRDesc: "註冊BTCC 最高可領取 500USDT贈金",
  inviteQRJoin: "掃一掃加入",
  inviteCopySuccess: "複製成功",
  inviteCopyError: "複製失敗",
  inviteFriendWin: "邀請好友輕鬆賺取",
  inviteWinPercent: "25%",
  inviteBack: "回饋",
  inviteNoRecord: "暫無記錄",
  inviteSlogan: "推薦好友完成交易，將可獲得高達<strong>500USDT</strong>現金",
  "您当前VIP等级,享受手续费折扣":
    "目前VIP等級：<span class='{level}'></span>目前VIP費率折扣：<strong>{current}</strong>繼續升級享受<strong>{next}</strong>折扣",
  VIP交易费率: "VIP交易費率",
  VIP等级: "VIP等級",
  账户资金: "總資產淨值",
  币币交易手续费: "幣幣交易手續費",
  合约交易手续费: "合約交易手續費",
  前往充值: "立即前往充值升級VIP",
  前往充币: "立即前往充幣",
  充提币手续费: "充提幣手續費",
  币种: "幣種",
  充币费用: "充幣費用",
  提币费用: "提幣費用",
  最小提币数量: "最小提幣數量",
  最小充币数量: "最小充幣數量",
  折扣: "{amount} 折扣",
  说明: "條款及細則：",
  说明1: "BTCC VIP採用自動升級機制，系統將根據VIP等級規則，自動處理VIP的升級。以下為不同VIP等級的更新時間：",
  说明2: "新版VIP系統中，用戶一旦升級便不再降級。",
  说明3: "每一筆的開倉/平倉手續費都將根據用戶當前所處的VIP等級進行收取。",
  说明4: "BTCC不分吃單費率與掛單費率。",
  说明5: "*以上規則已於2023年 1 月 10 日 15:00（UTC+8）開始生效。",
  vip权益全面升级: "福利全面升級",
  生效时间: "生效時間：2022/04/25 00:00:00 (UTC+8)",
  其他货币: "其他貨幣",

  // 累计充值活动
  新手专享: "新手專享",
  新手专享豪礼送: " 新手專享好禮相送！",
  注册成功后等级赠金奖励:
    "註冊成功後{day}天內完成充值目標，即享相應等級贈金獎勵",
  立即报名: "登入參與活動",
  如何领取奖励: "如何領取獎勵",
  如何领取奖励第一步: "第一步：註冊",
  如何领取奖励第二步: "第二步：完成充值要求",
  如何领取奖励第三步: "第三步：自動發放贈金獎勵",
  立即买币: "快捷買幣",
  立即充币: "立即充幣",
  储值福利进度: "{coin}充值福利進度",
  充值升级提示:
    "註冊成功後{day}天內進行更多充值，可在活動期間賺取高達17,500USDT贈金獎勵",
  活动举例: "活動舉例",
  有效充值: "有效充值",
  累计返利: "累計贈金(USDT) ",
  活动规则及条款: "活動規則及條款",
  活动版权: "本次活动最终解释权归BTCC所有。如有任何疑问，",
  请联系客服: "請聯繫客服",
  报名成功: "報名成功",
  充币提示:
    "您可以選擇以下任何一種幣種充值，點擊幣種可查看您的該幣種充值進度。",
  我已了解: "我知道了",
  充值升级下一级:
    "您已獲得<strong>{bonus}</strong>贈金，再累計充值<strong>{amount}</strong>，解鎖下一級獎勵！",
  不符合新手报名条件: "不符合新手活動條件",
  前往福利中心参与其他活动: "前往活動中心參與其他熱門活動",

  我的赠金记录: "我的贈金獎勵記錄",
  福利中心: "免費獎勵",
  立即登录: "立即登錄",
  免费注册: "免費註冊",
  "参与活动": "參與活動",
  "立即参与": "立即參與",
  "继续充值": "繼續充值",
  captcha_desc: "向右拖動滑塊填充拼圖",
  当前等级: "當前等級:",
  当前: "",
  参数: " ",
  兑换手续费减免: "兌換手續費減免",
  提币手续费减免: "提幣手續費減免",
  月总成交量USD: "30日總成交量(USD)",
  账户资产USD: "帳戶資產(USD)",
  账户资产: "帳戶資產:",
  继续升级: "繼續升級享受{amount}折扣",
  gotIt: "明白了",
  我的30日成交量: "我的過去30日成交量",
  最近30天成交的交易合约: "最近30日成交的交易合約，以USD計算",
  我的资产: "我的資產",
  昨日账户资产: "昨日帳戶資產（包含所有幣種）的價值*，以USD計算<span>*每天00:00 (UTC+8)更新</span>",
  "title": "10日交易挑戰",
  "solgen": "做任務開啟盲盒！最高領取210USDT贈金及交易手續費全免！",
  "super": "超級大盲盒",
  "super_award": "隨機{min}-{max}USDT贈金",
  "supper_task": "領取任意7個盲盒後可領取",
  "supper_tip": "需要先完成每日任務領取7個盲盒",
  "supper_open": "開啟盲盒",
  "day": "當前任務：第{day}天",
  "award_fee": "隨機{min}%-{max}%合約手續費返現",
  "award_bouns": "隨機{min}-{max}USDT贈金",
  "task_complete": "已完成<span>{reach}/{total}</span>交易",
  "contract_task": "合約任務",
  "task_need": "完成任意<span>{num}</span>筆交易",
  "get_award_fee": "已領取：{amount}%手續費返現",
  "get_award_bouns": "已領取：{amount}USDT贈金",
  "award_overdue": "已過期",
  "award_hasget": "已領取",
  "award_toget": "待領取",
  "task_nostart": "未開始",
  "task_ongoing": "未完成",
  "task_rules": "活動規則",
  "task_rules_content1": "1. 參與條件：2022年12月23日 10:00:00 (台灣時間) 後的VIP用戶。VIP0用戶只需在此活動上線後升級至]VIP1或以上的等級便會自動參與此活動。",
  "task_rules_content1_desc": "2022年12月23日 10:00:00 (台灣時間) 前已經從VIP0升級到VIP1-9的用戶無法參與此活動。",
  "task_rules_content2":  "2. 當用戶升級至VIP1或以上後，活動便會立即開始。此活動業的資訊於每日5:00AM(台灣時間)更新",
  "task_rules_content3": "3. 必須完成當日交易任務才能開啟該日盲盒獎勵。在當日結算時間前未完成當天交易任務即失效。當天結算時間後自動重製交易筆數，並自動開啟隔日的交易任務。",
  "task_rules_content4": "4. 盲盒共計兩種獎勵形式，手續費返現與USDT贈金。手續費返現為現金獎勵，領取後將自動發放至帳戶中，現金可交易可提取。贈金僅能作用於合約交易時產生的手續費折扣，將根據不同的VIP等級進行一定比例的折扣。",
  "task_rules_content5":  "5. 手續費返現獎勵只會返現當天計算在活動中的交易筆數，超出當天任務的交易筆數不會進行返現。",
  "task_rules_content6":  "6. 大盲盒開啟條件為必須先完成任意7天的交易任務並開啟7個盲盒，如在活動結束前為滿足條件則無法開啟大盲盒。",
  "task_rules_content7":  "7. 盲盒獎勵存在隨機性和機率性，獎勵內容僅供參考，具體以實際獲得獎勵為準。",
  "task_rules_content8":  "8. 盲盒獎勵即時到帳。數據統計和獎勵發放可能存在延遲，如果狀態沒有即時更新，請稍後再試或者聯繫客服查詢。",
  "task_rules_content9":  "9. 如您的帳號在活動期間被限制或判定為異常狀態，您將無法開啟盲盒。",
  "task_rules_content10":  "10. 交易包含開倉、平倉及強平；交易產品包括所有USDT合約及幣本位合約；交易筆數統計交易的次數。",
  "task_rules_content11":  "其他條款",
  "task_rules_content12":  "1. 活動期間，如有惡意刷量行為、大量註冊小號、自買自賣、相互對敲等作弊行為，BTCC將保留立即取消任何表現出欺詐行為跡象的參與者參與資格及權益。",
  "task_rules_content13":  "2. BTCC保留自行取消、修改活動或活動資格的權力，無需事先通知。",
  "task_rules_content14":  "3. BTCC保留對本次活動的最終解釋權。如有疑問，請聯繫客服。",
  "complete_task": "成功完成<span>{num}</span>個交易",
  "no_standard": "完成{num}個交易，未達標"
};



// WEBPACK FOOTER //
// ./src/locales/zh-TW.js